var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecordingPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21875 3.5C4.80454 3.5 4.46875 3.83579 4.46875 4.25V11.75C4.46875 12.1642 4.80454 12.5 5.21875 12.5C5.63296 12.5 5.96875 12.1642 5.96875 11.75V4.25C5.96875 3.83579 5.63296 3.5 5.21875 3.5ZM11.2188 3.5C10.8045 3.5 10.4688 3.83579 10.4688 4.25V11.75C10.4688 12.1642 10.8045 12.5 11.2188 12.5C11.633 12.5 11.9688 12.1642 11.9688 11.75V4.25C11.9688 3.83579 11.633 3.5 11.2188 3.5Z",
    fill: "white",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordingPause);
export default __webpack_public_path__ + "static/media/icon-recording-pause.06f6d58d296604172a27ded160d285f4.svg";
export { ForwardRef as ReactComponent };